import ProfileImage from './profile.svg'

export {
  ProfileImage,
}
